// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const RgaBOReportDates = props =>
    <section className='registrations-review-dates form-group'>
        <label className='registrations-review-date-label form-group-title form-group-title asterisk-after'>
            <FormattedMessage id={props.label}/>
        </label>
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.dateRange.max}
            minDate={props.dateRange.min}
            onDateChange={props.onDateChange}
        />
    </section>;

RgaBOReportDates.displayName = 'RgaBOReportDates';
RgaBOReportDates.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default RgaBOReportDates;



// WEBPACK FOOTER //
// ./src/rga/reports/components/rga-bo-dates-criteria.js